import { render, staticRenderFns } from "./SituacaoCar.vue?vue&type=template&id=7a1a9a07&lang=pug"
import script from "./SituacaoCar.vue?vue&type=script&lang=js"
export * from "./SituacaoCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports